import { Alert, Button } from 'antd';
import type { DeployArtifactPolicy, DeployPolicyView } from '../../api/deploy';

const TIER_LABEL: Record<string, string> = {
  free: '免费版',
  basic: '基础版',
  pro: '专业版',
  enterprise: '尊享版',
};

/** 套餐门禁提示（产物未开放/套餐不足/额度用尽 → 引导升级；对齐参考图「套餐不足请升级」） */
export default function TierGateAlert({
  artifact,
  policy,
  label,
  testId,
}: {
  artifact?: DeployArtifactPolicy;
  policy?: DeployPolicyView | null;
  label: string;
  testId?: string;
}) {
  if (!artifact) return null;
  if (artifact.allowed) {
    return (
      <div style={{ fontSize: 12, color: '#888', marginBottom: 12 }} data-testid={testId ? `${testId}-allowed` : undefined}>
        {label}：可用
        {artifact.monthlyQuota >= 0 ? `（本月剩余 ${artifact.remaining}/${artifact.monthlyQuota} 次）` : '（不限次）'}
      </div>
    );
  }
  const required = artifact.requiredTier ? TIER_LABEL[artifact.requiredTier] ?? artifact.requiredTier : '';
  const exhausted = artifact.enabled && !artifact.requiredTier && artifact.monthlyQuota >= 0 && artifact.remaining <= 0;
  const text = !artifact.enabled
    ? `${label}已暂停开放，请联系管理员`
    : exhausted
      ? `本月${label}额度已用完（${artifact.monthlyQuota} 次/月）`
      : `该产物需${required}及以上套餐可用，您当前为${TIER_LABEL[policy?.tier ?? ''] ?? policy?.tier ?? '免费版'}`;
  return (
    <Alert
      type="warning"
      showIcon
      style={{ marginBottom: 12 }}
      data-testid={testId}
      message={text}
      action={
        !exhausted && policy?.promo?.link ? (
          <Button size="small" type="primary" onClick={() => window.open(policy.promo.link, '_blank')}>
            升级套餐
          </Button>
        ) : undefined
      }
    />
  );
}
